import EmpresaService from "common/services/EmpresaService"
import { useState } from "react"

const empresaService = new EmpresaService()

const normalizeTelefono = (telefono = "") => telefono?.replace(/ /g, "")

const useSearchEmpresa = ({ onSearchEmpresa }: $TSMigrationFixMe) => {
  const [searchingEmpresa, setSearchingEmpresa] = useState(false)

  const searchEmpresaByNif = (nif: $TSMigrationFixMe) => {
    setSearchingEmpresa(true)
    empresaService
      .getByNif(nif)
      .then(({ data }) => {
        if (onSearchEmpresa) {
          onSearchEmpresa({
            ...data,
            telefono: normalizeTelefono(data.telefono),
          })
        }
      })
      .finally(() => setSearchingEmpresa(false))
  }

  return {
    searchingEmpresa,
    searchEmpresaByNif,
  }
}

export default useSearchEmpresa
